import React, { useRef, useState } from 'react'
import { Button, ButtonVariant } from './Button'
import { useInterval } from 'react-use'

interface CountdownButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  startMinutes: number
  onTimeout: () => void
  variant?: ButtonVariant
  className?: string
  disabled?: boolean
  children?: React.ReactNode
}

export const CountdownButton: React.FC<CountdownButtonProps> = ({ startMinutes, onTimeout, variant, className, disabled, children, ...rest }) => {
  const [secondsLeft, setSecondsLeft] = useState(startMinutes * 60)
  const onTimeoutRef = useRef(onTimeout)

  useInterval(() => {
    setSecondsLeft((prev) => {
      if (prev <= 1) {
        onTimeoutRef.current()
        return 0
      }
      return prev - 1
    })
  }, 1000)

  const handleClick = () => {
    onTimeout()
  }

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60
  const counter = `${minutes}:${seconds.toString().padStart(2, '0')}`

  return (
    <Button onClick={handleClick} className={className} variant={variant} disabled={disabled} {...rest}>
      {children} {counter}
    </Button>
  )
}
